import { render } from "./ItemQueue.vue?vue&type=template&id=5454508f&scoped=true"
import script from "./ItemQueue.vue?vue&type=script&lang=js"
export * from "./ItemQueue.vue?vue&type=script&lang=js"

import "./ItemQueue.vue?vue&type=style&index=0&id=5454508f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5454508f"]])

export default __exports__